/**
 * Created by ppatton on 12/21/2016.
 */
import { Injectable } from '@angular/core';

@Injectable()
export class LMPersonalizationPersistenceService {
  getPersonalization(key: string): object {
    lscache.setBucket('personalization');
    const cache = lscache.get(key);
    if (!cache || typeof cache !== 'object') {
      return {}; // safety
    }
    return cache;
  }

  /**
   * Save to local storage.
   * @param key - any unique string value
   * @param payload - must be a json object.
   */
  persistPersonalization(key: string, payload: any): void {
    lscache.setBucket('personalization');
    lscache.set(key, payload);
  }

  removePersonalization(key: string): void {
    lscache.setBucket('personalization');
    lscache.remove(key);
  }
}
